import classnames from 'classnames';
import React, { useState } from 'react';

import { YearDropdownOptions } from './YearDropdownOptions';

interface YearDropdownProps {
  minYear?: number;
  maxYear?: number;
  onChange: (year: number) => void;
  currentYear: number;
}

export const YearDropdown: React.FC<YearDropdownProps> = ({ currentYear, onChange, maxYear, minYear }) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const onYearChange = (year: number) => {
    onChange(year);
    setDropdownVisible(false);
  };

  const renderReadView = () => (
    <div
      className={classnames('react-datepicker__year-read-view', {
        'react-datepicker__year-read-view--hidden': dropdownVisible,
      })}
      data-test-id="datepicker-year-read-view"
      onClick={() => setDropdownVisible(true)}
    >
      <span className="react-datepicker__year-read-view--selected-year">{currentYear}</span>
      <span className="react-datepicker__year-read-view--down-arrow" />
    </div>
  );

  return (
    <div className="react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--scroll">
      {dropdownVisible && (
        <YearDropdownOptions
          minYear={minYear}
          maxYear={maxYear}
          currentYear={currentYear}
          onChange={onYearChange}
          onCancel={() => setDropdownVisible(false)}
        />
      )}
      {renderReadView()}
    </div>
  );
};
